const i=(c,e=6)=>c?`${c.slice(0,e)}...${c.slice(e*-1)}`:"";var r=i;export{r as default};
